import React, { useEffect, useState } from "react";
import { RxChevronDown, RxChevronUp } from "react-icons/rx";
import AdsComponents from "../ads/AdsComponents";
import fallbackFaq from './fallbackFaq'

export const FAQContent = ({ faqs }) => {
  const [openIndex, setOpenIndex] = useState(null);
  const [faq, setFaq] = useState(fallbackFaq)
  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    if(faqs.length){
      setFaq(faqs)
    } else {
      setFaq(fallbackFaq)
    }
  }, [faqs])

  return (
    <div
      className="min-h-screen py-10 px-4 text-white"
      style={{
        background: "linear-gradient(to bottom left, #413072, #08080B)",
      }}
    >
      <div className="w-[80%] mx-auto">
        <h1 className="text-3xl font-bold mb-6 text-white text-left">FAQ</h1>
        <div className="flex flex-row gap-5">
          <div className="bg-white w-2/3 p-4 rounded-lg">
            <div className="flex flex-col lg:flex-row gap-6">
              <div className="flex-1 space-y-4">
                {faq.map((faqItem, index) => (
                  <div key={index} className="bg-white text-black rounded-lg">
                    <div
                      className="flex justify-between items-center cursor-pointer text-base font-semibold p-2"
                      onClick={() => toggleFAQ(index)}
                    >
                      <span>{faqItem.question}</span>
                      {openIndex === index ? (
                        <RxChevronUp className="w-6 h-6" />
                      ) : (
                        <RxChevronDown className="w-6 h-6" />
                      )}
                    </div>
                    {openIndex === index && (
                      <div className="mt-1 py-3 text-sm text-gray-800 p-2 ">
                        {faqItem.answer}
                      </div>
                    )}
                    {index !== faq.length - 1 && (
                      <hr className="mt-4 border-gray-300" />
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="w-1/3">
            <AdsComponents />
          </div>
        </div>
      </div>
    </div>
  );
};
